var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.node)?_c('AxDialog',{on:{"after-leave":_vm.cancel},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('AxCreateFolder',{attrs:{"parent-folder":_vm.folderId},on:{"submit":_vm.submit,"cancel":_vm.cancel}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }